import { render, staticRenderFns } from "./RumourHome.vue?vue&type=template&id=f534990c"
import script from "./RumourHome.vue?vue&type=script&lang=js"
export * from "./RumourHome.vue?vue&type=script&lang=js"
import style0 from "./RumourHome.vue?vue&type=style&index=0&id=f534990c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f534990c')) {
      api.createRecord('f534990c', component.options)
    } else {
      api.reload('f534990c', component.options)
    }
    module.hot.accept("./RumourHome.vue?vue&type=template&id=f534990c", function () {
      api.rerender('f534990c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rumour/RumourHome.vue"
export default component.exports